import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/services/app.services';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-create-survy',
  templateUrl: './create-survy.component.html',
  styleUrls: ['./create-survy.component.css']
})
export class CreateSurvyComponent implements OnInit {

  constructor(private appServ: AppService, private route: ActivatedRoute, private router: Router) { }

  ngOnInit(): void {
    const token = this.route.snapshot.params.token;
    const survey = this.route.snapshot.params.survey;
    console.log('survey: ', survey, ' token: ', token);
    console.log('snapshot: ', this.route.snapshot);

    this.appServ.createSurvey(survey,token).subscribe(newToken =>{
      console.log('new token: ', newToken);
    }, error => {
      console.log('error: ', error);
      this.router.navigate(['/'+error.error.text]);
    })
  }

}
